import axios from 'axios'
import _ from 'lodash'
const state = {
  loading: false,
  orders: {},
  data: {
    phrase: '',
    date_from: '',
    date_to: '',
    status: ''
  }
}

const mutations = {
  setOrders(state, data) {
    state.orders = data
  },
  setLoading(state, value) {
    state.loading = value
  }
}

const getters = {
  data(state) {
    return state.data
  },
  getOrders(state) {
    return state.orders
  },
  getLoading(state) {
    return state.loading
  }
}

const actions = {
  getOrders({ commit, dispatch, state }, data) {
    state.orders = {}
    if (!state.loading) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: '/api/orders',
          data: {
            phrase: state.data.phrase,
            date_from: state.data.date_from,
            date_to: state.data.date_to,
            status: state.data.status
          }
        })
          .then(response => {
            commit('setOrders', response.data)
            commit('setLoading', false)
            resolve(response)
          })
          .catch(error => {
            commit('setLoading', false)
            reject(error)
          })
      })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
